module.exports = "./src/client/static/xml/fattura_pa_v1.2.xsl?949ac959802e4af9e0ac10592ecdf12f";